import React from 'react';
import ForbiddenView from './ForbiddenView';

class PermissionErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { isForbidden: false };
    }

    static getDerivedStateFromError(error) {
        if (error?.status === 403) {
            return { isForbidden: true };
        }
        // 403이 아닌 에러는 상위 ErrorBoundary로 전파
        return null;
    }

    componentDidUpdate(prevProps) {
        // 라우트 변경 시 상태 초기화 (다른 페이지로 이동하면 ForbiddenView 해제)
        if (prevProps.resetKey !== this.props.resetKey) {
            this.setState({ isForbidden: false });
        }
    }

    render() {
        if (this.state.isForbidden) {
            return <ForbiddenView />;
        }
        return this.props.children;
    }
}

export default PermissionErrorBoundary;
